import React, { useCallback, useEffect, useState } from 'react'
import { useCurrent, useFetch, usePost } from '../../../hooks'
import { MwSelectorMulti,MwSelector, MwSpinner,TagList, MwInputText, MwButton } from '../../ui';
import {LangArrayToObjKeyValue} from '../../../utils/global'
import { useTranslation } from 'react-i18next';
import { PRODUCT_FORM_SECTION_CLASS, normalizeApiCollection } from '../productUi';

const ProductLinks = ({
    productCategorySelected,
    setProductCategorySelected,
    productBrandSelected,
    setProductBrandSelected,
    productTags,
    setProductTags,
    genProductCode,
    setGenProductCode,
    setProductCode,
    productCode
}) => {
    const {currentTenantId,currentCompanyId,currentLangId} = useCurrent();
    const {data:categories,loading:categoriesLoading} = useFetch(`${process.env.REACT_APP_PRODUCTS_API_SERVER_BASE_URL}/categories/${currentTenantId}/${currentCompanyId}`)
    const {data:brands,loading:brandsLoading} = useFetch(`${process.env.REACT_APP_PRODUCTS_API_SERVER_BASE_URL}/brands/${currentTenantId}/${currentCompanyId}`)
    const {data:tags,loading:tagsLoading} = useFetch(`${process.env.REACT_APP_PRODUCTS_API_SERVER_BASE_URL}/tags/${currentTenantId}/${currentCompanyId}`)
    const {data:genCodeResult,loading:genCodeLoading,postData:getGenProductCode} = usePost()
    const [t] = useTranslation('global')
    
    const [categoriesList,setCategoriesList] = useState([]);
    const [brandsList,setBrandsList] = useState([]);
    const [tagsList,setTagsList] = useState([]);
    const [genCode,setgenCode] = useState(false);
    
    const genProductCodeHandler = useCallback(async(cat) => {
        setGenProductCode('')
        const _url = `${process.env.REACT_APP_PRODUCTS_API_SERVER_BASE_URL}/gencode/${cat}`
        await getGenProductCode(_url,{tenantId:currentTenantId,companyId:currentCompanyId})
    }, [currentCompanyId, currentTenantId, getGenProductCode, setGenProductCode])
    
    useEffect(() => {
        if(categories && !categoriesLoading ){
            const itemList = normalizeApiCollection(categories).map((el) => ({
                label:LangArrayToObjKeyValue(el.categoryName)?.[currentLangId],
                value:el._id,
                lang:currentLangId,
                data:el,
            }));
            setCategoriesList(itemList.filter((item) => item.label));
        }
    },[categories,categoriesLoading,currentLangId]);


    useEffect(() => {
        if(brands && !brandsLoading) {
            const itemList = normalizeApiCollection(brands)
                .map((el) => {
                    const label = LangArrayToObjKeyValue(el.brandName)?.[currentLangId];
                    if (!label) return null;

                    return {
                        label,
                        value: el._id,
                        lang: currentLangId,
                        data: el,
                    };
                })
                .filter(Boolean);

            setBrandsList(itemList);
        }
    },[brands,brandsLoading,currentLangId]);

    useEffect(() => {
        if(tags && !tagsLoading) {
            const itemList = normalizeApiCollection(tags)
                .map((el) => LangArrayToObjKeyValue(el.tagName)?.[currentLangId])
                .filter(Boolean);
            setTagsList(itemList);
        }
    }, [tags, tagsLoading, currentLangId]);

    
    useEffect(() => {
        if(productCategorySelected.length > 0 && genCode ){
            setProductCode(null);
            
            if(productCategorySelected[0]?.data?.categoryCode){
                genProductCodeHandler(productCategorySelected[0]?.data?.categoryCode)
                setGenProductCode(productCategorySelected[0]?.data?.categoryCode)
            }
        }
    },[genCode, genProductCodeHandler, productCategorySelected, setGenProductCode, setProductCode])

    useEffect(() => {
        if(genCodeResult){
            const _newcode = genProductCode +'-'+ (parseInt(genCodeResult.data)+1).toString().padStart(4,'0')
            setGenProductCode(_newcode)
        }
    },[genCodeResult,genProductCode,setGenProductCode])

    return (
        <>
            {
                (categories && brands && tags && !categoriesLoading && !brandsLoading && !tagsLoading ) ? 
                <div className='grid gap-4 lg:grid-cols-[1.35fr_0.85fr]'>
                    <div className={`${PRODUCT_FORM_SECTION_CLASS} relative flex flex-col gap-4`}>
                        <div className='flex gap-2'>
                            <div className='z-50 flex-1'>
                                <MwSelectorMulti
                                    label={t('product.category')} 
                                    initalValue={t('product.choose_category')} 
                                    dataType='labelValue'
                                    _data={categoriesList}
                                    withAddNew={false}
                                    selectedItem={productCategorySelected}
                                    setSelectedItem={setProductCategorySelected}
                                    className='z-20'
                                />
                            </div>
                            <div className='w-40'>
                                {genCode && genProductCode ? (
                                    <div className='flex'>
                                        <div>
                                            <MwInputText
                                                label={t('product.auto_product_code')} 
                                                id='genProductCode' 
                                                value={genProductCode}
                                                disabled={true}
                                                onChange={(e) =>setGenProductCode(e.target.value)}
                                            />
                                        </div>
                                        {!productCode && genCode && (
                                            <div className='pt-5'>
                                                <MwButton classNameCustom="w-20" actionType='button' onClick={()=>{setProductCode(genProductCode)}}>
                                                    {t('product.applyGeneratedCode')}
                                                </MwButton>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className='pt-5'>
                                        <MwButton
                                            classNameCustom="w-40"
                                            actionType='button'
                                            type='secondary'
                                            disabled={!productCategorySelected || productCategorySelected.length === 0 || genCodeLoading}
                                            onClick={()=>setgenCode(true)}
                                        >
                                            {t('product.generateCode')}
                                        </MwButton>
                                    </div>
                                )}
                            </div>
                        </div>
                        <MwSelector
                            label={t('product.brand')}
                            initalValue={t('product.choose_brand')}
                            dataType='labelValue'
                            _data={brandsList}
                            withAddNew={false}
                            selectedItem={productBrandSelected}
                            setSelectedItem={setProductBrandSelected}
                            className='z-10'
                        />
                    </div>
                    <div className={`${PRODUCT_FORM_SECTION_CLASS} flex flex-col gap-3`}>
                        <TagList
                            tagList={productTags}
                            setTagList={setProductTags}
                            withLabel={true}
                            label={t('product.add_tags_label')}
                        />
                        {tagsList.length > 0 && (
                            <div className='flex flex-wrap gap-2'>
                                {tagsList.map((tag) => (
                                    <button
                                        key={tag}
                                        type="button"
                                        onClick={() => {
                                            if (!productTags.includes(tag)) {
                                                setProductTags([...productTags, tag]);
                                            }
                                        }}
                                        className={`rounded-full border px-3 py-1 text-xs transition-colors ${
                                            productTags.includes(tag)
                                                ? 'border-[#251658] bg-[#251658] text-white'
                                                : 'border-slate-200 bg-slate-50 text-slate-600 hover:border-[#251658]/20 hover:bg-[#251658]/5 hover:text-[#251658]'
                                        }`}
                                    >
                                        {tag}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div> : <MwSpinner/>
            } 
        </>
    )
}

export default ProductLinks
